import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { FiltersObject, isQueryParameter, VqlQuery } from "types";
import {
  AUTOMATIC_FLAT_RESPONSE_PARAMETER,
  FLAT_RESPONSE_PARAMETER,
  GRANULARITY_PARAMETER,
  VQL_PARAMETER,
} from "helpers/constants/miscellaneous";
import { extractValuesFromVqlQueries } from "helpers/utility/vqlHelpers";

function useAllQueryParamsFilters(): FiltersObject {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const filtersObject: FiltersObject = {};

    // Process regular query parameters
    params.forEach((value, key) => {
      if (isQueryParameter(key)) {
        filtersObject[key] = decodeURIComponent(value);
      }
    });
    if (params.has(AUTOMATIC_FLAT_RESPONSE_PARAMETER)) {
      filtersObject[FLAT_RESPONSE_PARAMETER] = decodeURIComponent(
        params.get(AUTOMATIC_FLAT_RESPONSE_PARAMETER)!,
      );
    }

    // Default to flat view when env var is set and no view params are present
    if (
      process.env.REACT_APP_DEFAULT_FLAT_VIEW === "true" &&
      !params.has(GRANULARITY_PARAMETER) &&
      !params.has(FLAT_RESPONSE_PARAMETER) &&
      !params.has(AUTOMATIC_FLAT_RESPONSE_PARAMETER)
    ) {
      filtersObject[FLAT_RESPONSE_PARAMETER] = "true";
    }

    // Also extract values from VQL parameter
    const vqlParam = params.get(VQL_PARAMETER);
    if (vqlParam) {
      try {
        const vqlQueries = JSON.parse(vqlParam) as VqlQuery[];
        const extractedValues = extractValuesFromVqlQueries(vqlQueries);

        // Merge extracted values into filtersObject
        Object.assign(filtersObject, extractedValues);
      } catch (error) {
        console.error("Error parsing VQL parameter:", error);
      }
    }

    return filtersObject;
  }, [search]);
}

export default useAllQueryParamsFilters;
